export const TIMEZONES = [
    {
        value: "Africa/Abidjan",
        title: "Africa/Abidjan GMT+0:00",
    },
    {
        value: "Africa/Accra",
        title: "Africa/Accra GMT+0:00",
    },
    {
        value: "Africa/Addis_Ababa",
        title: "Africa/Addis_Ababa GMT+3:00",
    },
    {
        value: "Africa/Algiers",
        title: "Africa/Algiers GMT+1:00",
    },
    {
        value: "Africa/Asmera",
        title: "Africa/Asmera GMT+3:00",
    },
    {
        value: "Africa/Bamako",
        title: "Africa/Bamako GMT+0:00",
    },
    {
        value: "Africa/Bangui",
        title: "Africa/Bangui GMT+1:00",
    },
    {
        value: "Africa/Banjul",
        title: "Africa/Banjul GMT+0:00",
    },
    {
        value: "Africa/Bissau",
        title: "Africa/Bissau GMT+0:00",
    },
    {
        value: "Africa/Blantyre",
        title: "Africa/Blantyre GMT+2:00",
    },
    {
        value: "Africa/Brazzaville",
        title: "Africa/Brazzaville GMT+1:00",
    },
    {
        value: "Africa/Bujumbura",
        title: "Africa/Bujumbura GMT+2:00",
    },
    {
        value: "Africa/Cairo",
        title: "Africa/Cairo GMT+2:00",
    },
    {
        value: "Africa/Casablanca",
        title: "Africa/Casablanca GMT+0:00",
    },
    {
        value: "Africa/Ceuta",
        title: "Africa/Ceuta GMT+1:00",
    },
    {
        value: "Africa/Conakry",
        title: "Africa/Conakry GMT+0:00",
    },
    {
        value: "Africa/Dakar",
        title: "Africa/Dakar GMT+0:00",
    },
    {
        value: "Africa/Dar_es_Salaam",
        title: "Africa/Dar_es_Salaam GMT+3:00",
    },
    {
        value: "Africa/Djibouti",
        title: "Africa/Djibouti GMT+3:00",
    },
    {
        value: "Africa/Douala",
        title: "Africa/Douala GMT+1:00",
    },
    {
        value: "Africa/El_Aaiun",
        title: "Africa/El_Aaiun GMT+0:00",
    },
    {
        value: "Africa/Freetown",
        title: "Africa/Freetown GMT+0:00",
    },
    {
        value: "Africa/Gaborone",
        title: "Africa/Gaborone GMT+2:00",
    },
    {
        value: "Africa/Harare",
        title: "Africa/Harare GMT+2:00",
    },
    {
        value: "Africa/Johannesburg",
        title: "Africa/Johannesburg GMT+2:00",
    },
    {
        value: "Africa/Juba",
        title: "Africa/Juba GMT+3:00",
    },
    {
        value: "Africa/Kampala",
        title: "Africa/Kampala GMT+3:00",
    },
    {
        value: "Africa/Khartoum",
        title: "Africa/Khartoum GMT+2:00",
    },
    {
        value: "Africa/Kigali",
        title: "Africa/Kigali GMT+2:00",
    },
    {
        value: "Africa/Kinshasa",
        title: "Africa/Kinshasa GMT+1:00",
    },
    {
        value: "Africa/Lagos",
        title: "Africa/Lagos GMT+1:00",
    },
    {
        value: "Africa/Libreville",
        title: "Africa/Libreville GMT+1:00",
    },
    {
        value: "Africa/Lome",
        title: "Africa/Lome GMT+0:00",
    },
    {
        value: "Africa/Luanda",
        title: "Africa/Luanda GMT+1:00",
    },
    {
        value: "Africa/Lubumbashi",
        title: "Africa/Lubumbashi GMT+2:00",
    },
    {
        value: "Africa/Lusaka",
        title: "Africa/Lusaka GMT+2:00",
    },
    {
        value: "Africa/Malabo",
        title: "Africa/Malabo GMT+1:00",
    },
    {
        value: "Africa/Maputo",
        title: "Africa/Maputo GMT+2:00",
    },
    {
        value: "Africa/Maseru",
        title: "Africa/Maseru GMT+2:00",
    },
    {
        value: "Africa/Mbabane",
        title: "Africa/Mbabane GMT+2:00",
    },
    {
        value: "Africa/Mogadishu",
        title: "Africa/Mogadishu GMT+3:00",
    },
    {
        value: "Africa/Monrovia",
        title: "Africa/Monrovia GMT+0:00",
    },
    {
        value: "Africa/Nairobi",
        title: "Africa/Nairobi GMT+3:00",
    },
    {
        value: "Africa/Ndjamena",
        title: "Africa/Ndjamena GMT+1:00",
    },
    {
        value: "Africa/Niamey",
        title: "Africa/Niamey GMT+1:00",
    },
    {
        value: "Africa/Nouakchott",
        title: "Africa/Nouakchott GMT+0:00",
    },
    {
        value: "Africa/Ouagadougou",
        title: "Africa/Ouagadougou GMT+0:00",
    },
    {
        value: "Africa/Porto-Novo",
        title: "Africa/Porto-Novo GMT+1:00",
    },
    {
        value: "Africa/Sao_Tome",
        title: "Africa/Sao_Tome GMT+0:00",
    },
    {
        value: "Africa/Tripoli",
        title: "Africa/Tripoli GMT+2:00",
    },
    {
        value: "Africa/Tunis",
        title: "Africa/Tunis GMT+1:00",
    },
    {
        value: "Africa/Windhoek",
        title: "Africa/Windhoek GMT+2:00",
    },
    {
        value: "America/Adak",
        title: "America/Adak GMT-10:00",
    },
    {
        value: "America/Anchorage",
        title: "America/Anchorage GMT-9:00",
    },
    {
        value: "America/Anguilla",
        title: "America/Anguilla GMT-4:00",
    },
    {
        value: "America/Antigua",
        title: "America/Antigua GMT-4:00",
    },
    {
        value: "America/Araguaina",
        title: "America/Araguaina GMT-3:00",
    },
    {
        value: "America/Argentina/La_Rioja",
        title: "America/Argentina/La_Rioja GMT-3:00",
    },
    {
        value: "America/Argentina/Rio_Gallegos",
        title: "America/Argentina/Rio_Gallegos GMT-3:00",
    },
    {
        value: "America/Argentina/Salta",
        title: "America/Argentina/Salta GMT-3:00",
    },
    {
        value: "America/Argentina/San_Juan",
        title: "America/Argentina/San_Juan GMT-3:00",
    },
    {
        value: "America/Argentina/San_Luis",
        title: "America/Argentina/San_Luis GMT-3:00",
    },
    {
        value: "America/Argentina/Tucuman",
        title: "America/Argentina/Tucuman GMT-3:00",
    },
    {
        value: "America/Argentina/Ushuaia",
        title: "America/Argentina/Ushuaia GMT-3:00",
    },
    {
        value: "America/Aruba",
        title: "America/Aruba GMT-4:00",
    },
    {
        value: "America/Asuncion",
        title: "America/Asuncion GMT-4:00",
    },
    {
        value: "America/Bahia",
        title: "America/Bahia GMT-3:00",
    },
    {
        value: "America/Bahia_Banderas",
        title: "America/Bahia_Banderas GMT-6:00",
    },
    {
        value: "America/Barbados",
        title: "America/Barbados GMT-4:00",
    },
    {
        value: "America/Belem",
        title: "America/Belem GMT-3:00",
    },
    {
        value: "America/Belize",
        title: "America/Belize GMT-6:00",
    },
    {
        value: "America/Blanc-Sablon",
        title: "America/Blanc-Sablon GMT-4:00",
    },
    {
        value: "America/Boa_Vista",
        title: "America/Boa_Vista GMT-4:00",
    },
    {
        value: "America/Bogota",
        title: "America/Bogota GMT-5:00",
    },
    {
        value: "America/Boise",
        title: "America/Boise GMT-7:00",
    },
    {
        value: "America/Buenos_Aires",
        title: "America/Buenos_Aires GMT-3:00",
    },
    {
        value: "America/Cambridge_Bay",
        title: "America/Cambridge_Bay GMT-7:00",
    },
    {
        value: "America/Campo_Grande",
        title: "America/Campo_Grande GMT-4:00",
    },
    {
        value: "America/Cancun",
        title: "America/Cancun GMT-5:00",
    },
    {
        value: "America/Caracas",
        title: "America/Caracas GMT-4:00",
    },
    {
        value: "America/Catamarca",
        title: "America/Catamarca GMT-3:00",
    },
    {
        value: "America/Cayenne",
        title: "America/Cayenne GMT-3:00",
    },
    {
        value: "America/Cayman",
        title: "America/Cayman GMT-5:00",
    },
    {
        value: "America/Chicago",
        title: "America/Chicago GMT-6:00",
    },
    {
        value: "America/Chihuahua",
        title: "America/Chihuahua GMT-7:00",
    },
    {
        value: "America/Coral_Harbour",
        title: "America/Coral_Harbour GMT-5:00",
    },
    {
        value: "America/Cordoba",
        title: "America/Cordoba GMT-3:00",
    },
    {
        value: "America/Costa_Rica",
        title: "America/Costa_Rica GMT-6:00",
    },
    {
        value: "America/Creston",
        title: "America/Creston GMT-7:00",
    },
    {
        value: "America/Cuiaba",
        title: "America/Cuiaba GMT-4:00",
    },
    {
        value: "America/Curacao",
        title: "America/Curacao GMT-4:00",
    },
    {
        value: "America/Danmarkshavn",
        title: "America/Danmarkshavn GMT+0:00",
    },
    {
        value: "America/Dawson",
        title: "America/Dawson GMT-8:00",
    },
    {
        value: "America/Dawson_Creek",
        title: "America/Dawson_Creek GMT-7:00",
    },
    {
        value: "America/Denver",
        title: "America/Denver GMT-7:00",
    },
    {
        value: "America/Detroit",
        title: "America/Detroit GMT-5:00",
    },
    {
        value: "America/Dominica",
        title: "America/Dominica GMT-4:00",
    },
    {
        value: "America/Edmonton",
        title: "America/Edmonton GMT-7:00",
    },
    {
        value: "America/Eirunepe",
        title: "America/Eirunepe GMT-5:00",
    },
    {
        value: "America/El_Salvador",
        title: "America/El_Salvador GMT-6:00",
    },
    {
        value: "America/Fort_Nelson",
        title: "America/Fort_Nelson GMT-7:00",
    },
    {
        value: "America/Fortaleza",
        title: "America/Fortaleza GMT-3:00",
    },
    {
        value: "America/Glace_Bay",
        title: "America/Glace_Bay GMT-4:00",
    },
    {
        value: "America/Godthab",
        title: "America/Godthab GMT-3:00",
    },
    {
        value: "America/Goose_Bay",
        title: "America/Goose_Bay GMT-4:00",
    },
    {
        value: "America/Grand_Turk",
        title: "America/Grand_Turk GMT-5:00",
    },
    {
        value: "America/Grenada",
        title: "America/Grenada GMT-4:00",
    },
    {
        value: "America/Guadeloupe",
        title: "America/Guadeloupe GMT-4:00",
    },
    {
        value: "America/Guatemala",
        title: "America/Guatemala GMT-6:00",
    },
    {
        value: "America/Guayaquil",
        title: "America/Guayaquil GMT-5:00",
    },
    {
        value: "America/Guyana",
        title: "America/Guyana GMT-4:00",
    },
    {
        value: "America/Halifax",
        title: "America/Halifax GMT-4:00",
    },
    {
        value: "America/Havana",
        title: "America/Havana GMT-5:00",
    },
    {
        value: "America/Hermosillo",
        title: "America/Hermosillo GMT-7:00",
    },
    {
        value: "America/Indiana/Knox",
        title: "America/Indiana/Knox GMT-6:00",
    },
    {
        value: "America/Indiana/Marengo",
        title: "America/Indiana/Marengo GMT-5:00",
    },
    {
        value: "America/Indiana/Petersburg",
        title: "America/Indiana/Petersburg GMT-5:00",
    },
    {
        value: "America/Indiana/Tell_City",
        title: "America/Indiana/Tell_City GMT-6:00",
    },
    {
        value: "America/Indiana/Vevay",
        title: "America/Indiana/Vevay GMT-5:00",
    },
    {
        value: "America/Indiana/Vincennes",
        title: "America/Indiana/Vincennes GMT-5:00",
    },
    {
        value: "America/Indiana/Winamac",
        title: "America/Indiana/Winamac GMT-5:00",
    },
    {
        value: "America/Indianapolis",
        title: "America/Indianapolis GMT-5:00",
    },
    {
        value: "America/Inuvik",
        title: "America/Inuvik GMT-7:00",
    },
    {
        value: "America/Iqaluit",
        title: "America/Iqaluit GMT-5:00",
    },
    {
        value: "America/Jamaica",
        title: "America/Jamaica GMT-5:00",
    },
    {
        value: "America/Jujuy",
        title: "America/Jujuy GMT-3:00",
    },
    {
        value: "America/Juneau",
        title: "America/Juneau GMT-9:00",
    },
    {
        value: "America/Kentucky/Monticello",
        title: "America/Kentucky/Monticello GMT-5:00",
    },
    {
        value: "America/Kralendijk",
        title: "America/Kralendijk GMT-4:00",
    },
    {
        value: "America/La_Paz",
        title: "America/La_Paz GMT-4:00",
    },
    {
        value: "America/Lima",
        title: "America/Lima GMT-5:00",
    },
    {
        value: "America/Los_Angeles",
        title: "America/Los_Angeles GMT-8:00",
    },
    {
        value: "America/Louisville",
        title: "America/Louisville GMT-5:00",
    },
    {
        value: "America/Lower_Princes",
        title: "America/Lower_Princes GMT-4:00",
    },
    {
        value: "America/Maceio",
        title: "America/Maceio GMT-3:00",
    },
    {
        value: "America/Managua",
        title: "America/Managua GMT-6:00",
    },
    {
        value: "America/Manaus",
        title: "America/Manaus GMT-4:00",
    },
    {
        value: "America/Marigot",
        title: "America/Marigot GMT-4:00",
    },
    {
        value: "America/Martinique",
        title: "America/Martinique GMT-4:00",
    },
    {
        value: "America/Matamoros",
        title: "America/Matamoros GMT-6:00",
    },
    {
        value: "America/Mazatlan",
        title: "America/Mazatlan GMT-7:00",
    },
    {
        value: "America/Mendoza",
        title: "America/Mendoza GMT-3:00",
    },
    {
        value: "America/Menominee",
        title: "America/Menominee GMT-6:00",
    },
    {
        value: "America/Merida",
        title: "America/Merida GMT-6:00",
    },
    {
        value: "America/Metlakatla",
        title: "America/Metlakatla GMT-9:00",
    },
    {
        value: "America/Mexico_City",
        title: "America/Mexico_City GMT-6:00",
    },
    {
        value: "America/Miquelon",
        title: "America/Miquelon GMT-3:00",
    },
    {
        value: "America/Moncton",
        title: "America/Moncton GMT-4:00",
    },
    {
        value: "America/Monterrey",
        title: "America/Monterrey GMT-6:00",
    },
    {
        value: "America/Montevideo",
        title: "America/Montevideo GMT-3:00",
    },
    {
        value: "America/Montreal",
        title: "America/Montreal GMT-5:00",
    },
    {
        value: "America/Montserrat",
        title: "America/Montserrat GMT-4:00",
    },
    {
        value: "America/Nassau",
        title: "America/Nassau GMT-5:00",
    },
    {
        value: "America/New_York",
        title: "America/New_York GMT-5:00",
    },
    {
        value: "America/Nipigon",
        title: "America/Nipigon GMT-5:00",
    },
    {
        value: "America/Nome",
        title: "America/Nome GMT-9:00",
    },
    {
        value: "America/Noronha",
        title: "America/Noronha GMT-2:00",
    },
    {
        value: "America/North_Dakota/Beulah",
        title: "America/North_Dakota/Beulah GMT-6:00",
    },
    {
        value: "America/North_Dakota/Center",
        title: "America/North_Dakota/Center GMT-6:00",
    },
    {
        value: "America/North_Dakota/New_Salem",
        title: "America/North_Dakota/New_Salem GMT-6:00",
    },
    {
        value: "America/Ojinaga",
        title: "America/Ojinaga GMT-7:00",
    },
    {
        value: "America/Panama",
        title: "America/Panama GMT-5:00",
    },
    {
        value: "America/Pangnirtung",
        title: "America/Pangnirtung GMT-5:00",
    },
    {
        value: "America/Paramaribo",
        title: "America/Paramaribo GMT-3:00",
    },
    {
        value: "America/Phoenix",
        title: "America/Phoenix GMT-7:00",
    },
    {
        value: "America/Port-au-Prince",
        title: "America/Port-au-Prince GMT-5:00",
    },
    {
        value: "America/Port_of_Spain",
        title: "America/Port_of_Spain GMT-4:00",
    },
    {
        value: "America/Porto_Velho",
        title: "America/Porto_Velho GMT-4:00",
    },
    {
        value: "America/Puerto_Rico",
        title: "America/Puerto_Rico GMT-4:00",
    },
    {
        value: "America/Punta_Arenas",
        title: "America/Punta_Arenas GMT-3:00",
    },
    {
        value: "America/Rainy_River",
        title: "America/Rainy_River GMT-6:00",
    },
    {
        value: "America/Rankin_Inlet",
        title: "America/Rankin_Inlet GMT-6:00",
    },
    {
        value: "America/Recife",
        title: "America/Recife GMT-3:00",
    },
    {
        value: "America/Regina",
        title: "America/Regina GMT-6:00",
    },
    {
        value: "America/Resolute",
        title: "America/Resolute GMT-6:00",
    },
    {
        value: "America/Rio_Branco",
        title: "America/Rio_Branco GMT-5:00",
    },
    {
        value: "America/Santa_Isabel",
        title: "America/Santa_Isabel GMT-8:00",
    },
    {
        value: "America/Santarem",
        title: "America/Santarem GMT-3:00",
    },
    {
        value: "America/Santiago",
        title: "America/Santiago GMT-4:00",
    },
    {
        value: "America/Santo_Domingo",
        title: "America/Santo_Domingo GMT-4:00",
    },
    {
        value: "America/Sao_Paulo",
        title: "America/Sao_Paulo GMT-3:00",
    },
    {
        value: "America/Scoresbysund",
        title: "America/Scoresbysund GMT-1:00",
    },
    {
        value: "America/Sitka",
        title: "America/Sitka GMT-9:00",
    },
    {
        value: "America/St_Barthelemy",
        title: "America/St_Barthelemy GMT-4:00",
    },
    {
        value: "America/St_Johns",
        title: "America/St_Johns GMT-4:30",
    },
    {
        value: "America/St_Kitts",
        title: "America/St_Kitts GMT-4:00",
    },
    {
        value: "America/St_Lucia",
        title: "America/St_Lucia GMT-4:00",
    },
    {
        value: "America/St_Thomas",
        title: "America/St_Thomas GMT-4:00",
    },
    {
        value: "America/St_Vincent",
        title: "America/St_Vincent GMT-4:00",
    },
    {
        value: "America/Swift_Current",
        title: "America/Swift_Current GMT-6:00",
    },
    {
        value: "America/Tegucigalpa",
        title: "America/Tegucigalpa GMT-6:00",
    },
    {
        value: "America/Thule",
        title: "America/Thule GMT-4:00",
    },
    {
        value: "America/Thunder_Bay",
        title: "America/Thunder_Bay GMT-5:00",
    },
    {
        value: "America/Tijuana",
        title: "America/Tijuana GMT-8:00",
    },
    {
        value: "America/Toronto",
        title: "America/Toronto GMT-5:00",
    },
    {
        value: "America/Tortola",
        title: "America/Tortola GMT-4:00",
    },
    {
        value: "America/Vancouver",
        title: "America/Vancouver GMT-8:00",
    },
    {
        value: "America/Whitehorse",
        title: "America/Whitehorse GMT-8:00",
    },
    {
        value: "America/Winnipeg",
        title: "America/Winnipeg GMT-6:00",
    },
    {
        value: "America/Yakutat",
        title: "America/Yakutat GMT-9:00",
    },
    {
        value: "America/Yellowknife",
        title: "America/Yellowknife GMT-7:00",
    },
    {
        value: "Asia/Aden",
        title: "Asia/Aden GMT+3:00",
    },
    {
        value: "Asia/Almaty",
        title: "Asia/Almaty GMT+6:00",
    },
    {
        value: "Asia/Amman",
        title: "Asia/Amman GMT+2:00",
    },
    {
        value: "Asia/Anadyr",
        title: "Asia/Anadyr GMT+12:00",
    },
    {
        value: "Asia/Aqtau",
        title: "Asia/Aqtau GMT+5:00",
    },
    {
        value: "Asia/Aqtobe",
        title: "Asia/Aqtobe GMT+5:00",
    },
    {
        value: "Asia/Ashgabat",
        title: "Asia/Ashgabat GMT+5:00",
    },
    {
        value: "Asia/Atyrau",
        title: "Asia/Atyrau GMT+5:00",
    },
    {
        value: "Asia/Baghdad",
        title: "Asia/Baghdad GMT+3:00",
    },
    {
        value: "Asia/Bahrain",
        title: "Asia/Bahrain GMT+3:00",
    },
    {
        value: "Asia/Baku",
        title: "Asia/Baku GMT+4:00",
    },
    {
        value: "Asia/Bangkok",
        title: "Asia/Bangkok GMT+7:00",
    },
    {
        value: "Asia/Barnaul",
        title: "Asia/Barnaul GMT+7:00",
    },
    {
        value: "Asia/Beirut",
        title: "Asia/Beirut GMT+2:00",
    },
    {
        value: "Asia/Bishkek",
        title: "Asia/Bishkek GMT+6:00",
    },
    {
        value: "Asia/Brunei",
        title: "Asia/Brunei GMT+8:00",
    },
    {
        value: "Asia/Calcutta",
        title: "Asia/Calcutta GMT+5:30",
    },
    {
        value: "Asia/Chita",
        title: "Asia/Chita GMT+9:00",
    },
    {
        value: "Asia/Choibalsan",
        title: "Asia/Choibalsan GMT+8:00",
    },
    {
        value: "Asia/Colombo",
        title: "Asia/Colombo GMT+5:30",
    },
    {
        value: "Asia/Damascus",
        title: "Asia/Damascus GMT+2:00",
    },
    {
        value: "Asia/Dhaka",
        title: "Asia/Dhaka GMT+6:00",
    },
    {
        value: "Asia/Dili",
        title: "Asia/Dili GMT+9:00",
    },
    {
        value: "Asia/Dubai",
        title: "Asia/Dubai GMT+4:00",
    },
    {
        value: "Asia/Dushanbe",
        title: "Asia/Dushanbe GMT+5:00",
    },
    {
        value: "Asia/Famagusta",
        title: "Asia/Famagusta GMT+2:00",
    },
    {
        value: "Asia/Gaza",
        title: "Asia/Gaza GMT+2:00",
    },
    {
        value: "Asia/Hebron",
        title: "Asia/Hebron GMT+2:00",
    },
    {
        value: "Asia/Hong_Kong",
        title: "Asia/Hong_Kong GMT+8:00",
    },
    {
        value: "Asia/Hovd",
        title: "Asia/Hovd GMT+7:00",
    },
    {
        value: "Asia/Irkutsk",
        title: "Asia/Irkutsk GMT+8:00",
    },
    {
        value: "Asia/Jakarta",
        title: "Asia/Jakarta GMT+7:00",
    },
    {
        value: "Asia/Jayapura",
        title: "Asia/Jayapura GMT+9:00",
    },
    {
        value: "Asia/Jerusalem",
        title: "Asia/Jerusalem GMT+2:00",
    },
    {
        value: "Asia/Kabul",
        title: "Asia/Kabul GMT+4:30",
    },
    {
        value: "Asia/Kamchatka",
        title: "Asia/Kamchatka GMT+12:00",
    },
    {
        value: "Asia/Karachi",
        title: "Asia/Karachi GMT+5:00",
    },
    {
        value: "Asia/Katmandu",
        title: "Asia/Katmandu GMT+5:45",
    },
    {
        value: "Asia/Khandyga",
        title: "Asia/Khandyga GMT+9:00",
    },
    {
        value: "Asia/Krasnoyarsk",
        title: "Asia/Krasnoyarsk GMT+7:00",
    },
    {
        value: "Asia/Kuala_Lumpur",
        title: "Asia/Kuala_Lumpur GMT+8:00",
    },
    {
        value: "Asia/Kuching",
        title: "Asia/Kuching GMT+8:00",
    },
    {
        value: "Asia/Kuwait",
        title: "Asia/Kuwait GMT+3:00",
    },
    {
        value: "Asia/Macau",
        title: "Asia/Macau GMT+8:00",
    },
    {
        value: "Asia/Magadan",
        title: "Asia/Magadan GMT+11:00",
    },
    {
        value: "Asia/Makassar",
        title: "Asia/Makassar GMT+8:00",
    },
    {
        value: "Asia/Manila",
        title: "Asia/Manila GMT+8:00",
    },
    {
        value: "Asia/Muscat",
        title: "Asia/Muscat GMT+4:00",
    },
    {
        value: "Asia/Nicosia",
        title: "Asia/Nicosia GMT+2:00",
    },
    {
        value: "Asia/Novokuznetsk",
        title: "Asia/Novokuznetsk GMT+7:00",
    },
    {
        value: "Asia/Novosibirsk",
        title: "Asia/Novosibirsk GMT+7:00",
    },
    {
        value: "Asia/Omsk",
        title: "Asia/Omsk GMT+6:00",
    },
    {
        value: "Asia/Oral",
        title: "Asia/Oral GMT+5:00",
    },
    {
        value: "Asia/Phnom_Penh",
        title: "Asia/Phnom_Penh GMT+7:00",
    },
    {
        value: "Asia/Pontianak",
        title: "Asia/Pontianak GMT+7:00",
    },
    {
        value: "Asia/Pyongyang",
        title: "Asia/Pyongyang GMT+9:00",
    },
    {
        value: "Asia/Qatar",
        title: "Asia/Qatar GMT+3:00",
    },
    {
        value: "Asia/Qostanay",
        title: "Asia/Qostanay GMT+6:00",
    },
    {
        value: "Asia/Qyzylorda",
        title: "Asia/Qyzylorda GMT+5:00",
    },
    {
        value: "Asia/Rangoon",
        title: "Asia/Rangoon GMT+6:30",
    },
    {
        value: "Asia/Riyadh",
        title: "Asia/Riyadh GMT+3:00",
    },
    {
        value: "Asia/Saigon",
        title: "Asia/Saigon GMT+7:00",
    },
    {
        value: "Asia/Sakhalin",
        title: "Asia/Sakhalin GMT+11:00",
    },
    {
        value: "Asia/Samarkand",
        title: "Asia/Samarkand GMT+5:00",
    },
    {
        value: "Asia/Seoul",
        title: "Asia/Seoul GMT+9:00",
    },
    {
        value: "Asia/Shanghai",
        title: "Asia/Shanghai GMT+8:00",
    },
    {
        value: "Asia/Singapore",
        title: "Asia/Singapore GMT+8:00",
    },
    {
        value: "Asia/Srednekolymsk",
        title: "Asia/Srednekolymsk GMT+11:00",
    },
    {
        value: "Asia/Taipei",
        title: "Asia/Taipei GMT+8:00",
    },
    {
        value: "Asia/Tashkent",
        title: "Asia/Tashkent GMT+5:00",
    },
    {
        value: "Asia/Tbilisi",
        title: "Asia/Tbilisi GMT+4:00",
    },
    {
        value: "Asia/Tehran",
        title: "Asia/Tehran GMT+3:30",
    },
    {
        value: "Asia/Thimphu",
        title: "Asia/Thimphu GMT+6:00",
    },
    {
        value: "Asia/Tokyo",
        title: "Asia/Tokyo GMT+9:00",
    },
    {
        value: "Asia/Tomsk",
        title: "Asia/Tomsk GMT+7:00",
    },
    {
        value: "Asia/Ulaanbaatar",
        title: "Asia/Ulaanbaatar GMT+8:00",
    },
    {
        value: "Asia/Urumqi",
        title: "Asia/Urumqi GMT+6:00",
    },
    {
        value: "Asia/Ust-Nera",
        title: "Asia/Ust-Nera GMT+10:00",
    },
    {
        value: "Asia/Vientiane",
        title: "Asia/Vientiane GMT+7:00",
    },
    {
        value: "Asia/Vladivostok",
        title: "Asia/Vladivostok GMT+10:00",
    },
    {
        value: "Asia/Yakutsk",
        title: "Asia/Yakutsk GMT+9:00",
    },
    {
        value: "Asia/Yekaterinburg",
        title: "Asia/Yekaterinburg GMT+5:00",
    },
    {
        value: "Asia/Yerevan",
        title: "Asia/Yerevan GMT+4:00",
    },
    {
        value: "Atlantic/Azores",
        title: "Atlantic/Azores GMT-1:00",
    },
    {
        value: "Atlantic/Bermuda",
        title: "Atlantic/Bermuda GMT-4:00",
    },
    {
        value: "Atlantic/Canary",
        title: "Atlantic/Canary GMT+0:00",
    },
    {
        value: "Atlantic/Cape_Verde",
        title: "Atlantic/Cape_Verde GMT-1:00",
    },
    {
        value: "Atlantic/Faeroe",
        title: "Atlantic/Faeroe GMT+0:00",
    },
    {
        value: "Atlantic/Jan_Mayen",
        title: "Atlantic/Jan_Mayen GMT+1:00",
    },
    {
        value: "Atlantic/Madeira",
        title: "Atlantic/Madeira GMT+0:00",
    },
    {
        value: "Atlantic/Reykjavik",
        title: "Atlantic/Reykjavik GMT+0:00",
    },
    {
        value: "Atlantic/South_Georgia",
        title: "Atlantic/South_Georgia GMT-2:00",
    },
    {
        value: "Atlantic/St_Helena",
        title: "Atlantic/St_Helena GMT+0:00",
    },
    {
        value: "Atlantic/Stanley",
        title: "Atlantic/Stanley GMT-3:00",
    },
    {
        value: "Australia/Adelaide",
        title: "Australia/Adelaide GMT+9:30",
    },
    {
        value: "Australia/Brisbane",
        title: "Australia/Brisbane GMT+10:00",
    },
    {
        value: "Australia/Broken_Hill",
        title: "Australia/Broken_Hill GMT+9:30",
    },
    {
        value: "Australia/Currie",
        title: "Australia/Currie GMT+10:00",
    },
    {
        value: "Australia/Darwin",
        title: "Australia/Darwin GMT+9:30",
    },
    {
        value: "Australia/Eucla",
        title: "Australia/Eucla GMT+8:45",
    },
    {
        value: "Australia/Hobart",
        title: "Australia/Hobart GMT+10:00",
    },
    {
        value: "Australia/Lindeman",
        title: "Australia/Lindeman GMT+10:00",
    },
    {
        value: "Australia/Lord_Howe",
        title: "Australia/Lord_Howe GMT+10:30",
    },
    {
        value: "Australia/Melbourne",
        title: "Australia/Melbourne GMT+10:00",
    },
    {
        value: "Australia/Perth",
        title: "Australia/Perth GMT+8:00",
    },
    {
        value: "Australia/Sydney",
        title: "Australia/Sydney GMT+10:00",
    },
    {
        value: "Africa/Abidjan",
        title: "Africa/Abidjan GMT+0:00",
    },
    {
        value: "Africa/Accra",
        title: "Africa/Accra GMT+0:00",
    },
    {
        value: "Africa/Addis_Ababa",
        title: "Africa/Addis_Ababa GMT+3:00",
    },
    {
        value: "Africa/Algiers",
        title: "Africa/Algiers GMT+1:00",
    },
    {
        value: "Africa/Asmera",
        title: "Africa/Asmera GMT+3:00",
    },
    {
        value: "Africa/Bamako",
        title: "Africa/Bamako GMT+0:00",
    },
    {
        value: "Africa/Bangui",
        title: "Africa/Bangui GMT+1:00",
    },
    {
        value: "Africa/Banjul",
        title: "Africa/Banjul GMT+0:00",
    },
    {
        value: "Africa/Bissau",
        title: "Africa/Bissau GMT+0:00",
    },
    {
        value: "Africa/Blantyre",
        title: "Africa/Blantyre GMT+2:00",
    },
    {
        value: "Africa/Brazzaville",
        title: "Africa/Brazzaville GMT+1:00",
    },
    {
        value: "Africa/Bujumbura",
        title: "Africa/Bujumbura GMT+2:00",
    },
    {
        value: "Africa/Cairo",
        title: "Africa/Cairo GMT+2:00",
    },
    {
        value: "Africa/Casablanca",
        title: "Africa/Casablanca GMT+0:00",
    },
    {
        value: "Africa/Ceuta",
        title: "Africa/Ceuta GMT+1:00",
    },
    {
        value: "Africa/Conakry",
        title: "Africa/Conakry GMT+0:00",
    },
    {
        value: "Africa/Dakar",
        title: "Africa/Dakar GMT+0:00",
    },
    {
        value: "Africa/Dar_es_Salaam",
        title: "Africa/Dar_es_Salaam GMT+3:00",
    },
    {
        value: "Africa/Djibouti",
        title: "Africa/Djibouti GMT+3:00",
    },
    {
        value: "Africa/Douala",
        title: "Africa/Douala GMT+1:00",
    },
    {
        value: "Africa/El_Aaiun",
        title: "Africa/El_Aaiun GMT+0:00",
    },
    {
        value: "Africa/Freetown",
        title: "Africa/Freetown GMT+0:00",
    },
    {
        value: "Africa/Gaborone",
        title: "Africa/Gaborone GMT+2:00",
    },
    {
        value: "Africa/Harare",
        title: "Africa/Harare GMT+2:00",
    },
    {
        value: "Africa/Johannesburg",
        title: "Africa/Johannesburg GMT+2:00",
    },
    {
        value: "Africa/Juba",
        title: "Africa/Juba GMT+3:00",
    },
    {
        value: "Africa/Kampala",
        title: "Africa/Kampala GMT+3:00",
    },
    {
        value: "Africa/Khartoum",
        title: "Africa/Khartoum GMT+2:00",
    },
    {
        value: "Africa/Kigali",
        title: "Africa/Kigali GMT+2:00",
    },
    {
        value: "Africa/Kinshasa",
        title: "Africa/Kinshasa GMT+1:00",
    },
    {
        value: "Africa/Lagos",
        title: "Africa/Lagos GMT+1:00",
    },
    {
        value: "Africa/Libreville",
        title: "Africa/Libreville GMT+1:00",
    },
    {
        value: "Africa/Lome",
        title: "Africa/Lome GMT+0:00",
    },
    {
        value: "Africa/Luanda",
        title: "Africa/Luanda GMT+1:00",
    },
    {
        value: "Africa/Lubumbashi",
        title: "Africa/Lubumbashi GMT+2:00",
    },
    {
        value: "Africa/Lusaka",
        title: "Africa/Lusaka GMT+2:00",
    },
    {
        value: "Africa/Malabo",
        title: "Africa/Malabo GMT+1:00",
    },
    {
        value: "Africa/Maputo",
        title: "Africa/Maputo GMT+2:00",
    },
    {
        value: "Africa/Maseru",
        title: "Africa/Maseru GMT+2:00",
    },
    {
        value: "Africa/Mbabane",
        title: "Africa/Mbabane GMT+2:00",
    },
    {
        value: "Africa/Mogadishu",
        title: "Africa/Mogadishu GMT+3:00",
    },
    {
        value: "Africa/Monrovia",
        title: "Africa/Monrovia GMT+0:00",
    },
    {
        value: "Africa/Nairobi",
        title: "Africa/Nairobi GMT+3:00",
    },
    {
        value: "Africa/Ndjamena",
        title: "Africa/Ndjamena GMT+1:00",
    },
    {
        value: "Africa/Niamey",
        title: "Africa/Niamey GMT+1:00",
    },
    {
        value: "Africa/Nouakchott",
        title: "Africa/Nouakchott GMT+0:00",
    },
    {
        value: "Africa/Ouagadougou",
        title: "Africa/Ouagadougou GMT+0:00",
    },
    {
        value: "Africa/Porto-Novo",
        title: "Africa/Porto-Novo GMT+1:00",
    },
    {
        value: "Africa/Sao_Tome",
        title: "Africa/Sao_Tome GMT+0:00",
    },
    {
        value: "Africa/Tripoli",
        title: "Africa/Tripoli GMT+2:00",
    },
    {
        value: "Africa/Tunis",
        title: "Africa/Tunis GMT+1:00",
    },
    {
        value: "Africa/Windhoek",
        title: "Africa/Windhoek GMT+2:00",
    },
    {
        value: "America/Adak",
        title: "America/Adak GMT-10:00",
    },
    {
        value: "America/Anchorage",
        title: "America/Anchorage GMT-9:00",
    },
    {
        value: "America/Anguilla",
        title: "America/Anguilla GMT-4:00",
    },
    {
        value: "America/Antigua",
        title: "America/Antigua GMT-4:00",
    },
    {
        value: "America/Araguaina",
        title: "America/Araguaina GMT-3:00",
    },
    {
        value: "America/Argentina/La_Rioja",
        title: "America/Argentina/La_Rioja GMT-3:00",
    },
    {
        value: "America/Argentina/Rio_Gallegos",
        title: "America/Argentina/Rio_Gallegos GMT-3:00",
    },
    {
        value: "America/Argentina/Salta",
        title: "America/Argentina/Salta GMT-3:00",
    },
    {
        value: "America/Argentina/San_Juan",
        title: "America/Argentina/San_Juan GMT-3:00",
    },
    {
        value: "America/Argentina/San_Luis",
        title: "America/Argentina/San_Luis GMT-3:00",
    },
    {
        value: "America/Argentina/Tucuman",
        title: "America/Argentina/Tucuman GMT-3:00",
    },
    {
        value: "America/Argentina/Ushuaia",
        title: "America/Argentina/Ushuaia GMT-3:00",
    },
    {
        value: "America/Aruba",
        title: "America/Aruba GMT-4:00",
    },
    {
        value: "America/Asuncion",
        title: "America/Asuncion GMT-4:00",
    },
    {
        value: "America/Bahia",
        title: "America/Bahia GMT-3:00",
    },
    {
        value: "America/Bahia_Banderas",
        title: "America/Bahia_Banderas GMT-6:00",
    },
    {
        value: "America/Barbados",
        title: "America/Barbados GMT-4:00",
    },
    {
        value: "America/Belem",
        title: "America/Belem GMT-3:00",
    },
    {
        value: "America/Belize",
        title: "America/Belize GMT-6:00",
    },
    {
        value: "America/Blanc-Sablon",
        title: "America/Blanc-Sablon GMT-4:00",
    },
    {
        value: "America/Boa_Vista",
        title: "America/Boa_Vista GMT-4:00",
    },
    {
        value: "America/Bogota",
        title: "America/Bogota GMT-5:00",
    },
    {
        value: "America/Boise",
        title: "America/Boise GMT-7:00",
    },
    {
        value: "America/Buenos_Aires",
        title: "America/Buenos_Aires GMT-3:00",
    },
    {
        value: "America/Cambridge_Bay",
        title: "America/Cambridge_Bay GMT-7:00",
    },
    {
        value: "America/Campo_Grande",
        title: "America/Campo_Grande GMT-4:00",
    },
    {
        value: "America/Cancun",
        title: "America/Cancun GMT-5:00",
    },
    {
        value: "America/Caracas",
        title: "America/Caracas GMT-4:00",
    },
    {
        value: "America/Catamarca",
        title: "America/Catamarca GMT-3:00",
    },
    {
        value: "America/Cayenne",
        title: "America/Cayenne GMT-3:00",
    },
    {
        value: "America/Cayman",
        title: "America/Cayman GMT-5:00",
    },
    {
        value: "America/Chicago",
        title: "America/Chicago GMT-6:00",
    },
    {
        value: "America/Chihuahua",
        title: "America/Chihuahua GMT-7:00",
    },
    {
        value: "America/Coral_Harbour",
        title: "America/Coral_Harbour GMT-5:00",
    },
    {
        value: "America/Cordoba",
        title: "America/Cordoba GMT-3:00",
    },
    {
        value: "America/Costa_Rica",
        title: "America/Costa_Rica GMT-6:00",
    },
    {
        value: "America/Creston",
        title: "America/Creston GMT-7:00",
    },
    {
        value: "America/Cuiaba",
        title: "America/Cuiaba GMT-4:00",
    },
    {
        value: "America/Curacao",
        title: "America/Curacao GMT-4:00",
    },
    {
        value: "America/Danmarkshavn",
        title: "America/Danmarkshavn GMT+0:00",
    },
    {
        value: "America/Dawson",
        title: "America/Dawson GMT-8:00",
    },
    {
        value: "America/Dawson_Creek",
        title: "America/Dawson_Creek GMT-7:00",
    },
    {
        value: "America/Denver",
        title: "America/Denver GMT-7:00",
    },
    {
        value: "America/Detroit",
        title: "America/Detroit GMT-5:00",
    },
    {
        value: "America/Dominica",
        title: "America/Dominica GMT-4:00",
    },
    {
        value: "America/Edmonton",
        title: "America/Edmonton GMT-7:00",
    },
    {
        value: "America/Eirunepe",
        title: "America/Eirunepe GMT-5:00",
    },
    {
        value: "America/El_Salvador",
        title: "America/El_Salvador GMT-6:00",
    },
    {
        value: "America/Fort_Nelson",
        title: "America/Fort_Nelson GMT-7:00",
    },
    {
        value: "America/Fortaleza",
        title: "America/Fortaleza GMT-3:00",
    },
    {
        value: "America/Glace_Bay",
        title: "America/Glace_Bay GMT-4:00",
    },
    {
        value: "America/Godthab",
        title: "America/Godthab GMT-3:00",
    },
    {
        value: "America/Goose_Bay",
        title: "America/Goose_Bay GMT-4:00",
    },
    {
        value: "America/Grand_Turk",
        title: "America/Grand_Turk GMT-5:00",
    },
    {
        value: "America/Grenada",
        title: "America/Grenada GMT-4:00",
    },
    {
        value: "America/Guadeloupe",
        title: "America/Guadeloupe GMT-4:00",
    },
    {
        value: "America/Guatemala",
        title: "America/Guatemala GMT-6:00",
    },
    {
        value: "America/Guayaquil",
        title: "America/Guayaquil GMT-5:00",
    },
    {
        value: "America/Guyana",
        title: "America/Guyana GMT-4:00",
    },
    {
        value: "America/Halifax",
        title: "America/Halifax GMT-4:00",
    },
    {
        value: "America/Havana",
        title: "America/Havana GMT-5:00",
    },
    {
        value: "America/Hermosillo",
        title: "America/Hermosillo GMT-7:00",
    },
    {
        value: "America/Indiana/Knox",
        title: "America/Indiana/Knox GMT-6:00",
    },
    {
        value: "America/Indiana/Marengo",
        title: "America/Indiana/Marengo GMT-5:00",
    },
    {
        value: "America/Indiana/Petersburg",
        title: "America/Indiana/Petersburg GMT-5:00",
    },
    {
        value: "America/Indiana/Tell_City",
        title: "America/Indiana/Tell_City GMT-6:00",
    },
    {
        value: "America/Indiana/Vevay",
        title: "America/Indiana/Vevay GMT-5:00",
    },
    {
        value: "America/Indiana/Vincennes",
        title: "America/Indiana/Vincennes GMT-5:00",
    },
    {
        value: "America/Indiana/Winamac",
        title: "America/Indiana/Winamac GMT-5:00",
    },
    {
        value: "America/Indianapolis",
        title: "America/Indianapolis GMT-5:00",
    },
    {
        value: "America/Inuvik",
        title: "America/Inuvik GMT-7:00",
    },
    {
        value: "America/Iqaluit",
        title: "America/Iqaluit GMT-5:00",
    },
    {
        value: "America/Jamaica",
        title: "America/Jamaica GMT-5:00",
    },
    {
        value: "America/Jujuy",
        title: "America/Jujuy GMT-3:00",
    },
    {
        value: "America/Juneau",
        title: "America/Juneau GMT-9:00",
    },
    {
        value: "America/Kentucky/Monticello",
        title: "America/Kentucky/Monticello GMT-5:00",
    },
    {
        value: "America/Kralendijk",
        title: "America/Kralendijk GMT-4:00",
    },
    {
        value: "America/La_Paz",
        title: "America/La_Paz GMT-4:00",
    },
    {
        value: "America/Lima",
        title: "America/Lima GMT-5:00",
    },
    {
        value: "America/Los_Angeles",
        title: "America/Los_Angeles GMT-8:00",
    },
    {
        value: "America/Louisville",
        title: "America/Louisville GMT-5:00",
    },
    {
        value: "America/Lower_Princes",
        title: "America/Lower_Princes GMT-4:00",
    },
    {
        value: "America/Maceio",
        title: "America/Maceio GMT-3:00",
    },
    {
        value: "America/Managua",
        title: "America/Managua GMT-6:00",
    },
    {
        value: "America/Manaus",
        title: "America/Manaus GMT-4:00",
    },
    {
        value: "America/Marigot",
        title: "America/Marigot GMT-4:00",
    },
    {
        value: "America/Martinique",
        title: "America/Martinique GMT-4:00",
    },
    {
        value: "America/Matamoros",
        title: "America/Matamoros GMT-6:00",
    },
    {
        value: "America/Mazatlan",
        title: "America/Mazatlan GMT-7:00",
    },
    {
        value: "America/Mendoza",
        title: "America/Mendoza GMT-3:00",
    },
    {
        value: "America/Menominee",
        title: "America/Menominee GMT-6:00",
    },
    {
        value: "America/Merida",
        title: "America/Merida GMT-6:00",
    },
    {
        value: "America/Metlakatla",
        title: "America/Metlakatla GMT-9:00",
    },
    {
        value: "America/Mexico_City",
        title: "America/Mexico_City GMT-6:00",
    },
    {
        value: "America/Miquelon",
        title: "America/Miquelon GMT-3:00",
    },
    {
        value: "America/Moncton",
        title: "America/Moncton GMT-4:00",
    },
    {
        value: "America/Monterrey",
        title: "America/Monterrey GMT-6:00",
    },
    {
        value: "America/Montevideo",
        title: "America/Montevideo GMT-3:00",
    },
    {
        value: "America/Montreal",
        title: "America/Montreal GMT-5:00",
    },
    {
        value: "America/Montserrat",
        title: "America/Montserrat GMT-4:00",
    },
    {
        value: "America/Nassau",
        title: "America/Nassau GMT-5:00",
    },
    {
        value: "America/New_York",
        title: "America/New_York GMT-5:00",
    },
    {
        value: "America/Nipigon",
        title: "America/Nipigon GMT-5:00",
    },
    {
        value: "America/Nome",
        title: "America/Nome GMT-9:00",
    },
    {
        value: "America/Noronha",
        title: "America/Noronha GMT-2:00",
    },
    {
        value: "America/North_Dakota/Beulah",
        title: "America/North_Dakota/Beulah GMT-6:00",
    },
    {
        value: "America/North_Dakota/Center",
        title: "America/North_Dakota/Center GMT-6:00",
    },
    {
        value: "America/North_Dakota/New_Salem",
        title: "America/North_Dakota/New_Salem GMT-6:00",
    },
    {
        value: "America/Ojinaga",
        title: "America/Ojinaga GMT-7:00",
    },
    {
        value: "America/Panama",
        title: "America/Panama GMT-5:00",
    },
    {
        value: "America/Pangnirtung",
        title: "America/Pangnirtung GMT-5:00",
    },
    {
        value: "America/Paramaribo",
        title: "America/Paramaribo GMT-3:00",
    },
    {
        value: "America/Phoenix",
        title: "America/Phoenix GMT-7:00",
    },
    {
        value: "America/Port-au-Prince",
        title: "America/Port-au-Prince GMT-5:00",
    },
    {
        value: "America/Port_of_Spain",
        title: "America/Port_of_Spain GMT-4:00",
    },
    {
        value: "America/Porto_Velho",
        title: "America/Porto_Velho GMT-4:00",
    },
    {
        value: "America/Puerto_Rico",
        title: "America/Puerto_Rico GMT-4:00",
    },
    {
        value: "America/Punta_Arenas",
        title: "America/Punta_Arenas GMT-3:00",
    },
    {
        value: "America/Rainy_River",
        title: "America/Rainy_River GMT-6:00",
    },
    {
        value: "America/Rankin_Inlet",
        title: "America/Rankin_Inlet GMT-6:00",
    },
    {
        value: "America/Recife",
        title: "America/Recife GMT-3:00",
    },
    {
        value: "America/Regina",
        title: "America/Regina GMT-6:00",
    },
    {
        value: "America/Resolute",
        title: "America/Resolute GMT-6:00",
    },
    {
        value: "America/Rio_Branco",
        title: "America/Rio_Branco GMT-5:00",
    },
    {
        value: "America/Santa_Isabel",
        title: "America/Santa_Isabel GMT-8:00",
    },
    {
        value: "America/Santarem",
        title: "America/Santarem GMT-3:00",
    },
    {
        value: "America/Santiago",
        title: "America/Santiago GMT-4:00",
    },
    {
        value: "America/Santo_Domingo",
        title: "America/Santo_Domingo GMT-4:00",
    },
    {
        value: "America/Sao_Paulo",
        title: "America/Sao_Paulo GMT-3:00",
    },
    {
        value: "America/Scoresbysund",
        title: "America/Scoresbysund GMT-1:00",
    },
    {
        value: "America/Sitka",
        title: "America/Sitka GMT-9:00",
    },
    {
        value: "America/St_Barthelemy",
        title: "America/St_Barthelemy GMT-4:00",
    },
    {
        value: "America/St_Johns",
        title: "America/St_Johns GMT-4:30",
    },
    {
        value: "America/St_Kitts",
        title: "America/St_Kitts GMT-4:00",
    },
    {
        value: "America/St_Lucia",
        title: "America/St_Lucia GMT-4:00",
    },
    {
        value: "America/St_Thomas",
        title: "America/St_Thomas GMT-4:00",
    },
    {
        value: "America/St_Vincent",
        title: "America/St_Vincent GMT-4:00",
    },
    {
        value: "America/Swift_Current",
        title: "America/Swift_Current GMT-6:00",
    },
    {
        value: "America/Tegucigalpa",
        title: "America/Tegucigalpa GMT-6:00",
    },
    {
        value: "America/Thule",
        title: "America/Thule GMT-4:00",
    },
    {
        value: "America/Thunder_Bay",
        title: "America/Thunder_Bay GMT-5:00",
    },
    {
        value: "America/Tijuana",
        title: "America/Tijuana GMT-8:00",
    },
    {
        value: "America/Toronto",
        title: "America/Toronto GMT-5:00",
    },
    {
        value: "America/Tortola",
        title: "America/Tortola GMT-4:00",
    },
    {
        value: "America/Vancouver",
        title: "America/Vancouver GMT-8:00",
    },
    {
        value: "America/Whitehorse",
        title: "America/Whitehorse GMT-8:00",
    },
    {
        value: "America/Winnipeg",
        title: "America/Winnipeg GMT-6:00",
    },
    {
        value: "America/Yakutat",
        title: "America/Yakutat GMT-9:00",
    },
    {
        value: "America/Yellowknife",
        title: "America/Yellowknife GMT-7:00",
    },
    {
        value: "Asia/Aden",
        title: "Asia/Aden GMT+3:00",
    },
    {
        value: "Asia/Almaty",
        title: "Asia/Almaty GMT+6:00",
    },
    {
        value: "Asia/Amman",
        title: "Asia/Amman GMT+2:00",
    },
    {
        value: "Asia/Anadyr",
        title: "Asia/Anadyr GMT+12:00",
    },
    {
        value: "Asia/Aqtau",
        title: "Asia/Aqtau GMT+5:00",
    },
    {
        value: "Asia/Aqtobe",
        title: "Asia/Aqtobe GMT+5:00",
    },
    {
        value: "Asia/Ashgabat",
        title: "Asia/Ashgabat GMT+5:00",
    },
    {
        value: "Asia/Atyrau",
        title: "Asia/Atyrau GMT+5:00",
    },
    {
        value: "Asia/Baghdad",
        title: "Asia/Baghdad GMT+3:00",
    },
    {
        value: "Asia/Bahrain",
        title: "Asia/Bahrain GMT+3:00",
    },
    {
        value: "Asia/Baku",
        title: "Asia/Baku GMT+4:00",
    },
    {
        value: "Asia/Bangkok",
        title: "Asia/Bangkok GMT+7:00",
    },
    {
        value: "Asia/Barnaul",
        title: "Asia/Barnaul GMT+7:00",
    },
    {
        value: "Asia/Beirut",
        title: "Asia/Beirut GMT+2:00",
    },
    {
        value: "Asia/Bishkek",
        title: "Asia/Bishkek GMT+6:00",
    },
    {
        value: "Asia/Brunei",
        title: "Asia/Brunei GMT+8:00",
    },
    {
        value: "Asia/Calcutta",
        title: "Asia/Calcutta GMT+5:30",
    },
    {
        value: "Asia/Chita",
        title: "Asia/Chita GMT+9:00",
    },
    {
        value: "Asia/Choibalsan",
        title: "Asia/Choibalsan GMT+8:00",
    },
    {
        value: "Asia/Colombo",
        title: "Asia/Colombo GMT+5:30",
    },
    {
        value: "Asia/Damascus",
        title: "Asia/Damascus GMT+2:00",
    },
    {
        value: "Asia/Dhaka",
        title: "Asia/Dhaka GMT+6:00",
    },
    {
        value: "Asia/Dili",
        title: "Asia/Dili GMT+9:00",
    },
    {
        value: "Asia/Dubai",
        title: "Asia/Dubai GMT+4:00",
    },
    {
        value: "Asia/Dushanbe",
        title: "Asia/Dushanbe GMT+5:00",
    },
    {
        value: "Asia/Famagusta",
        title: "Asia/Famagusta GMT+2:00",
    },
    {
        value: "Asia/Gaza",
        title: "Asia/Gaza GMT+2:00",
    },
    {
        value: "Asia/Hebron",
        title: "Asia/Hebron GMT+2:00",
    },
    {
        value: "Asia/Hong_Kong",
        title: "Asia/Hong_Kong GMT+8:00",
    },
    {
        value: "Asia/Hovd",
        title: "Asia/Hovd GMT+7:00",
    },
    {
        value: "Asia/Irkutsk",
        title: "Asia/Irkutsk GMT+8:00",
    },
    {
        value: "Asia/Jakarta",
        title: "Asia/Jakarta GMT+7:00",
    },
    {
        value: "Asia/Jayapura",
        title: "Asia/Jayapura GMT+9:00",
    },
    {
        value: "Asia/Jerusalem",
        title: "Asia/Jerusalem GMT+2:00",
    },
    {
        value: "Asia/Kabul",
        title: "Asia/Kabul GMT+4:30",
    },
    {
        value: "Asia/Kamchatka",
        title: "Asia/Kamchatka GMT+12:00",
    },
    {
        value: "Asia/Karachi",
        title: "Asia/Karachi GMT+5:00",
    },
    {
        value: "Asia/Katmandu",
        title: "Asia/Katmandu GMT+5:45",
    },
    {
        value: "Asia/Khandyga",
        title: "Asia/Khandyga GMT+9:00",
    },
    {
        value: "Asia/Krasnoyarsk",
        title: "Asia/Krasnoyarsk GMT+7:00",
    },
    {
        value: "Asia/Kuala_Lumpur",
        title: "Asia/Kuala_Lumpur GMT+8:00",
    },
    {
        value: "Asia/Kuching",
        title: "Asia/Kuching GMT+8:00",
    },
    {
        value: "Asia/Kuwait",
        title: "Asia/Kuwait GMT+3:00",
    },
    {
        value: "Asia/Macau",
        title: "Asia/Macau GMT+8:00",
    },
    {
        value: "Asia/Magadan",
        title: "Asia/Magadan GMT+11:00",
    },
    {
        value: "Asia/Makassar",
        title: "Asia/Makassar GMT+8:00",
    },
    {
        value: "Asia/Manila",
        title: "Asia/Manila GMT+8:00",
    },
    {
        value: "Asia/Muscat",
        title: "Asia/Muscat GMT+4:00",
    },
    {
        value: "Asia/Nicosia",
        title: "Asia/Nicosia GMT+2:00",
    },
    {
        value: "Asia/Novokuznetsk",
        title: "Asia/Novokuznetsk GMT+7:00",
    },
    {
        value: "Asia/Novosibirsk",
        title: "Asia/Novosibirsk GMT+7:00",
    },
    {
        value: "Asia/Omsk",
        title: "Asia/Omsk GMT+6:00",
    },
    {
        value: "Asia/Oral",
        title: "Asia/Oral GMT+5:00",
    },
    {
        value: "Asia/Phnom_Penh",
        title: "Asia/Phnom_Penh GMT+7:00",
    },
    {
        value: "Asia/Pontianak",
        title: "Asia/Pontianak GMT+7:00",
    },
    {
        value: "Asia/Pyongyang",
        title: "Asia/Pyongyang GMT+9:00",
    },
    {
        value: "Asia/Qatar",
        title: "Asia/Qatar GMT+3:00",
    },
    {
        value: "Asia/Qostanay",
        title: "Asia/Qostanay GMT+6:00",
    },
    {
        value: "Asia/Qyzylorda",
        title: "Asia/Qyzylorda GMT+5:00",
    },
    {
        value: "Asia/Rangoon",
        title: "Asia/Rangoon GMT+6:30",
    },
    {
        value: "Asia/Riyadh",
        title: "Asia/Riyadh GMT+3:00",
    },
    {
        value: "Asia/Saigon",
        title: "Asia/Saigon GMT+7:00",
    },
    {
        value: "Asia/Sakhalin",
        title: "Asia/Sakhalin GMT+11:00",
    },
    {
        value: "Asia/Samarkand",
        title: "Asia/Samarkand GMT+5:00",
    },
    {
        value: "Asia/Seoul",
        title: "Asia/Seoul GMT+9:00",
    },
    {
        value: "Asia/Shanghai",
        title: "Asia/Shanghai GMT+8:00",
    },
    {
        value: "Asia/Singapore",
        title: "Asia/Singapore GMT+8:00",
    },
    {
        value: "Asia/Srednekolymsk",
        title: "Asia/Srednekolymsk GMT+11:00",
    },
    {
        value: "Asia/Taipei",
        title: "Asia/Taipei GMT+8:00",
    },
    {
        value: "Asia/Tashkent",
        title: "Asia/Tashkent GMT+5:00",
    },
    {
        value: "Asia/Tbilisi",
        title: "Asia/Tbilisi GMT+4:00",
    },
    {
        value: "Asia/Tehran",
        title: "Asia/Tehran GMT+3:30",
    },
    {
        value: "Asia/Thimphu",
        title: "Asia/Thimphu GMT+6:00",
    },
    {
        value: "Asia/Tokyo",
        title: "Asia/Tokyo GMT+9:00",
    },
    {
        value: "Asia/Tomsk",
        title: "Asia/Tomsk GMT+7:00",
    },
    {
        value: "Asia/Ulaanbaatar",
        title: "Asia/Ulaanbaatar GMT+8:00",
    },
    {
        value: "Asia/Urumqi",
        title: "Asia/Urumqi GMT+6:00",
    },
    {
        value: "Asia/Ust-Nera",
        title: "Asia/Ust-Nera GMT+10:00",
    },
    {
        value: "Asia/Vientiane",
        title: "Asia/Vientiane GMT+7:00",
    },
    {
        value: "Asia/Vladivostok",
        title: "Asia/Vladivostok GMT+10:00",
    },
    {
        value: "Asia/Yakutsk",
        title: "Asia/Yakutsk GMT+9:00",
    },
    {
        value: "Asia/Yekaterinburg",
        title: "Asia/Yekaterinburg GMT+5:00",
    },
    {
        value: "Asia/Yerevan",
        title: "Asia/Yerevan GMT+4:00",
    },
    {
        value: "Atlantic/Azores",
        title: "Atlantic/Azores GMT-1:00",
    },
    {
        value: "Atlantic/Bermuda",
        title: "Atlantic/Bermuda GMT-4:00",
    },
    {
        value: "Atlantic/Canary",
        title: "Atlantic/Canary GMT+0:00",
    },
    {
        value: "Atlantic/Cape_Verde",
        title: "Atlantic/Cape_Verde GMT-1:00",
    },
    {
        value: "Atlantic/Faeroe",
        title: "Atlantic/Faeroe GMT+0:00",
    },
    {
        value: "Atlantic/Jan_Mayen",
        title: "Atlantic/Jan_Mayen GMT+1:00",
    },
    {
        value: "Atlantic/Madeira",
        title: "Atlantic/Madeira GMT+0:00",
    },
    {
        value: "Atlantic/Reykjavik",
        title: "Atlantic/Reykjavik GMT+0:00",
    },
    {
        value: "Atlantic/South_Georgia",
        title: "Atlantic/South_Georgia GMT-2:00",
    },
    {
        value: "Atlantic/St_Helena",
        title: "Atlantic/St_Helena GMT+0:00",
    },
    {
        value: "Atlantic/Stanley",
        title: "Atlantic/Stanley GMT-3:00",
    },
    {
        value: "Australia/Adelaide",
        title: "Australia/Adelaide GMT+9:30",
    },
    {
        value: "Australia/Brisbane",
        title: "Australia/Brisbane GMT+10:00",
    },
    {
        value: "Australia/Broken_Hill",
        title: "Australia/Broken_Hill GMT+9:30",
    },
    {
        value: "Australia/Currie",
        title: "Australia/Currie GMT+10:00",
    },
    {
        value: "Australia/Darwin",
        title: "Australia/Darwin GMT+9:30",
    },
    {
        value: "Australia/Eucla",
        title: "Australia/Eucla GMT+8:45",
    },
    {
        value: "Australia/Hobart",
        title: "Australia/Hobart GMT+10:00",
    },
    {
        value: "Australia/Lindeman",
        title: "Australia/Lindeman GMT+10:00",
    },
    {
        value: "Australia/Lord_Howe",
        title: "Australia/Lord_Howe GMT+10:30",
    },
    {
        value: "Australia/Melbourne",
        title: "Australia/Melbourne GMT+10:00",
    },
    {
        value: "Australia/Perth",
        title: "Australia/Perth GMT+8:00",
    },
    {
        value: "Australia/Sydney",
        title: "Australia/Sydney GMT+10:00",
    },
    {
        value: "Europe/Amsterdam",
        title: "Europe/Amsterdam GMT+1:00",
    },
    {
        value: "Europe/Andorra",
        title: "Europe/Andorra GMT+1:00",
    },
    {
        value: "Europe/Astrakhan",
        title: "Europe/Astrakhan GMT+4:00",
    },
    {
        value: "Europe/Athens",
        title: "Europe/Athens GMT+2:00",
    },
    {
        value: "Europe/Belgrade",
        title: "Europe/Belgrade GMT+1:00",
    },
    {
        value: "Europe/Berlin",
        title: "Europe/Berlin GMT+1:00",
    },
    {
        value: "Europe/Bratislava",
        title: "Europe/Bratislava GMT+1:00",
    },
    {
        value: "Europe/Brussels",
        title: "Europe/Brussels GMT+1:00",
    },
    {
        value: "Europe/Bucharest",
        title: "Europe/Bucharest GMT+2:00",
    },
    {
        value: "Europe/Budapest",
        title: "Europe/Budapest GMT+1:00",
    },
    {
        value: "Europe/Busingen",
        title: "Europe/Busingen GMT+1:00",
    },
    {
        value: "Europe/Chisinau",
        title: "Europe/Chisinau GMT+2:00",
    },
    {
        value: "Europe/Copenhagen",
        title: "Europe/Copenhagen GMT+1:00",
    },
    {
        value: "Europe/Dublin",
        title: "Europe/Dublin GMT+0:00",
    },
    {
        value: "Europe/Gibraltar",
        title: "Europe/Gibraltar GMT+1:00",
    },
    {
        value: "Europe/Guernsey",
        title: "Europe/Guernsey GMT+0:00",
    },
    {
        value: "Europe/Helsinki",
        title: "Europe/Helsinki GMT+2:00",
    },
    {
        value: "Europe/Isle_of_Man",
        title: "Europe/Isle_of_Man GMT+0:00",
    },
    {
        value: "Europe/Istanbul",
        title: "Europe/Istanbul GMT+3:00",
    },
    {
        value: "Europe/Jersey",
        title: "Europe/Jersey GMT+0:00",
    },
    {
        value: "Europe/Kaliningrad",
        title: "Europe/Kaliningrad GMT+2:00",
    },
    {
        value: "Europe/Kiev",
        title: "Europe/Kiev GMT+2:00",
    },
    {
        value: "Europe/Kirov",
        title: "Europe/Kirov GMT+3:00",
    },
    {
        value: "Europe/Lisbon",
        title: "Europe/Lisbon GMT+0:00",
    },
    {
        value: "Europe/Ljubljana",
        title: "Europe/Ljubljana GMT+1:00",
    },
    {
        value: "Europe/London",
        title: "Europe/London GMT+0:00",
    },
    {
        value: "Europe/Luxembourg",
        title: "Europe/Luxembourg GMT+1:00",
    },
    {
        value: "Europe/Madrid",
        title: "Europe/Madrid GMT+1:00",
    },
    {
        value: "Europe/Malta",
        title: "Europe/Malta GMT+1:00",
    },
    {
        value: "Europe/Mariehamn",
        title: "Europe/Mariehamn GMT+2:00",
    },
    {
        value: "Europe/Minsk",
        title: "Europe/Minsk GMT+3:00",
    },
    {
        value: "Europe/Monaco",
        title: "Europe/Monaco GMT+1:00",
    },
    {
        value: "Europe/Moscow",
        title: "Europe/Moscow GMT+3:00",
    },
    {
        value: "Europe/Oslo",
        title: "Europe/Oslo GMT+1:00",
    },
    {
        value: "Europe/Paris",
        title: "Europe/Paris GMT+1:00",
    },
    {
        value: "Europe/Podgorica",
        title: "Europe/Podgorica GMT+1:00",
    },
    {
        value: "Europe/Prague",
        title: "Europe/Prague GMT+1:00",
    },
    {
        value: "Europe/Riga",
        title: "Europe/Riga GMT+2:00",
    },
    {
        value: "Europe/Rome",
        title: "Europe/Rome GMT+1:00",
    },
    {
        value: "Europe/Samara",
        title: "Europe/Samara GMT+4:00",
    },
    {
        value: "Europe/San_Marino",
        title: "Europe/San_Marino GMT+1:00",
    },
    {
        value: "Europe/Sarajevo",
        title: "Europe/Sarajevo GMT+1:00",
    },
    {
        value: "Europe/Saratov",
        title: "Europe/Saratov GMT+4:00",
    },
    {
        value: "Europe/Simferopol",
        title: "Europe/Simferopol GMT+3:00",
    },
    {
        value: "Europe/Skopje",
        title: "Europe/Skopje GMT+1:00",
    },
    {
        value: "Europe/Sofia",
        title: "Europe/Sofia GMT+2:00",
    },
    {
        value: "Europe/Stockholm",
        title: "Europe/Stockholm GMT+1:00",
    },
    {
        value: "Europe/Tallinn",
        title: "Europe/Tallinn GMT+2:00",
    },
    {
        value: "Europe/Tirane",
        title: "Europe/Tirane GMT+1:00",
    },
    {
        value: "Europe/Ulyanovsk",
        title: "Europe/Ulyanovsk GMT+4:00",
    },
    {
        value: "Europe/Uzhgorod",
        title: "Europe/Uzhgorod GMT+2:00",
    },
    {
        value: "Europe/Vaduz",
        title: "Europe/Vaduz GMT+1:00",
    },
    {
        value: "Europe/Vatican",
        title: "Europe/Vatican GMT+1:00",
    },
    {
        value: "Europe/Vienna",
        title: "Europe/Vienna GMT+1:00",
    },
    {
        value: "Europe/Vilnius",
        title: "Europe/Vilnius GMT+2:00",
    },
    {
        value: "Europe/Volgograd",
        title: "Europe/Volgograd GMT+4:00",
    },
    {
        value: "Europe/Warsaw",
        title: "Europe/Warsaw GMT+1:00",
    },
    {
        value: "Europe/Zagreb",
        title: "Europe/Zagreb GMT+1:00",
    },
    {
        value: "Europe/Zaporozhye",
        title: "Europe/Zaporozhye GMT+2:00",
    },
    {
        value: "Europe/Zurich",
        title: "Europe/Zurich GMT+1:00",
    },
    {
        value: "Indian/Antananarivo",
        title: "Indian/Antananarivo GMT+3:00",
    },
    {
        value: "Indian/Chagos",
        title: "Indian/Chagos GMT+6:00",
    },
    {
        value: "Indian/Christmas",
        title: "Indian/Christmas GMT+7:00",
    },
    {
        value: "Indian/Cocos",
        title: "Indian/Cocos GMT+6:30",
    },
    {
        value: "Indian/Comoro",
        title: "Indian/Comoro GMT+3:00",
    },
    {
        value: "Indian/Kerguelen",
        title: "Indian/Kerguelen GMT+5:00",
    },
    {
        value: "Indian/Mahe",
        title: "Indian/Mahe GMT+4:00",
    },
    {
        value: "Indian/Maldives",
        title: "Indian/Maldives GMT+5:00",
    },
    {
        value: "Indian/Mauritius",
        title: "Indian/Mauritius GMT+4:00",
    },
    {
        value: "Indian/Mayotte",
        title: "Indian/Mayotte GMT+3:00",
    },
    {
        value: "Indian/Reunion",
        title: "Indian/Reunion GMT+4:00",
    },
    {
        value: "Pacific/Apia",
        title: "Pacific/Apia GMT+13:00",
    },
    {
        value: "Pacific/Auckland",
        title: "Pacific/Auckland GMT+12:00",
    },
    {
        value: "Pacific/Bougainville",
        title: "Pacific/Bougainville GMT+11:00",
    },
    {
        value: "Pacific/Chatham",
        title: "Pacific/Chatham GMT+12:45",
    },
    {
        value: "Pacific/Easter",
        title: "Pacific/Easter GMT-6:00",
    },
    {
        value: "Pacific/Efate",
        title: "Pacific/Efate GMT+11:00",
    },
    {
        value: "Pacific/Enderbury",
        title: "Pacific/Enderbury GMT+13:00",
    },
    {
        value: "Pacific/Fakaofo",
        title: "Pacific/Fakaofo GMT+13:00",
    },
    {
        value: "Pacific/Fiji",
        title: "Pacific/Fiji GMT+12:00",
    },
    {
        value: "Pacific/Funafuti",
        title: "Pacific/Funafuti GMT+12:00",
    },
    {
        value: "Pacific/Galapagos",
        title: "Pacific/Galapagos GMT-6:00",
    },
    {
        value: "Pacific/Gambier",
        title: "Pacific/Gambier GMT-9:00",
    },
    {
        value: "Pacific/Guadalcanal",
        title: "Pacific/Guadalcanal GMT+11:00",
    },
    {
        value: "Pacific/Guam",
        title: "Pacific/Guam GMT+10:00",
    },
    {
        value: "Pacific/Honolulu",
        title: "Pacific/Honolulu GMT-10:00",
    },
    {
        value: "Pacific/Johnston",
        title: "Pacific/Johnston GMT-10:00",
    },
    {
        value: "Pacific/Kiritimati",
        title: "Pacific/Kiritimati GMT+14:00",
    },
    {
        value: "Pacific/Kosrae",
        title: "Pacific/Kosrae GMT+11:00",
    },
    {
        value: "Pacific/Kwajalein",
        title: "Pacific/Kwajalein GMT+12:00",
    },
    {
        value: "Pacific/Majuro",
        title: "Pacific/Majuro GMT+12:00",
    },
    {
        value: "Pacific/Marquesas",
        title: "Pacific/Marquesas GMT-10:30",
    },
    {
        value: "Pacific/Midway",
        title: "Pacific/Midway GMT-11:00",
    },
    {
        value: "Pacific/Nauru",
        title: "Pacific/Nauru GMT+12:00",
    },
    {
        value: "Pacific/Niue",
        title: "Pacific/Niue GMT-11:00",
    },
    {
        value: "Pacific/Norfolk",
        title: "Pacific/Norfolk GMT+11:00",
    },
    {
        value: "Pacific/Noumea",
        title: "Pacific/Noumea GMT+11:00",
    },
    {
        value: "Pacific/Pago_Pago",
        title: "Pacific/Pago_Pago GMT-11:00",
    },
    {
        value: "Pacific/Palau",
        title: "Pacific/Palau GMT+9:00",
    },
    {
        value: "Pacific/Pitcairn",
        title: "Pacific/Pitcairn GMT-8:00",
    },
    {
        value: "Pacific/Ponape",
        title: "Pacific/Ponape GMT+11:00",
    },
    {
        value: "Pacific/Port_Moresby",
        title: "Pacific/Port_Moresby GMT+10:00",
    },
    {
        value: "Pacific/Rarotonga",
        title: "Pacific/Rarotonga GMT-10:00",
    },
    {
        value: "Pacific/Saipan",
        title: "Pacific/Saipan GMT+10:00",
    },
    {
        value: "Pacific/Tahiti",
        title: "Pacific/Tahiti GMT-10:00",
    },
    {
        value: "Pacific/Tarawa",
        title: "Pacific/Tarawa GMT+12:00",
    },
    {
        value: "Pacific/Tongatapu",
        title: "Pacific/Tongatapu GMT+13:00",
    },
    {
        value: "Pacific/Truk",
        title: "Pacific/Truk GMT+10:00",
    },
    {
        value: "Pacific/Wake",
        title: "Pacific/Wake GMT+12:00",
    },
    {
        value: "Pacific/Wallis",
        title: "Pacific/Wallis GMT+12:00",
    },
];
